module.exports = "/_next/static/images/mandy-nicole-4c4532b0469b607dbde4d77dd03f9a62.png";